import * as types from '../constants/ActionTypes';

export function clearUserNotification() {
    return {
        type: types.CLEAR_USER_NOTIFICATION
    };
}

export function clearErrorUserNotification() {
    return {
        type: types.CLEAR_ERROR_USER_NOTIFICATION
    };
}
